import { DIV, SPAN, INPUT, BUTTON, P, NODISPLAY } from "./dom";
import { Category, get, getCategory, getColor, Legend, PropKey } from "./state";
import { tr } from "./locale";

// const renderNoCategory = () => {
//   const picto = SPAN("color", "");
//   picto.style.background = get("colorDefault");
//   return DIV("legend-element unknown", picto, SPAN("label", tr("unknown")));
// };

const sizePicto = () => {
  const picto = DIV("picto-circles");
  return DIV(
    "legend-element circles",
    picto,
    SPAN("range", P("max", ">30"), P("min", "1")),
    SPAN("label", tr("structure_size")),
  );
};

const renderProgramDescription = (program: string) => {
  switch (program) {
    case "seeds":
      return SPAN("description", tr("seedsDescription"));
    case "blossom":
      return SPAN("description", tr("blossomDescription"));
    case "innovate":
      return SPAN("description", tr("innovateDescription"));
    case "coworking":
      return SPAN("description", tr("coworkingDescription"));
    case "share":
      return SPAN("description", tr('shareDescription'))
    case "pollinize":
      return SPAN("description", tr('pollinizeDescription'))
    default:
      return NODISPLAY();
  }
};

const renderLabel = (legend: Legend, category: Category) =>
  legend == "program"
    ? SPAN("label program", tr(category), renderProgramDescription(category))
    : SPAN("label", tr(category));

export const renderColorLegend = (
  legend: Legend,
  selectFeatures: (catKey: PropKey, catValue: string) => void,
) =>
  DIV(
    "legend color",
    ...getCategory(legend).map((cat, i) => {
      const className = get("category") === cat ? "selected" : "unselected";
      const picto = SPAN("color", "");
      picto.style.backgroundColor = getColor(i);
      return BUTTON(
        `legend-element ${className}`,
        () => selectFeatures(legend, cat),
        picto,
        renderLabel(legend, cat),
      );
    }),
    sizePicto(),
    // renderNoCategory(),
  );

export const renderSearchInput = (
  selectFeaturesFromSearchInput: (input: string) => void,
) => INPUT("search", selectFeaturesFromSearchInput);
